import SuperTokens, { SuperTokensConfig } from '@collinsonx/utils/supertokens';
import { superTokensConfig } from 'config/supertokens';

import { clientIsReady } from './errorHandling';

let isSuperTokensInitialized = false;

export const initSuperTokens = () => {
  if (isSuperTokensInitialized) return;

  if (clientIsReady) {
    const isInIframe = window.self !== window.top;

    SuperTokens.init(superTokensConfig({ isInIframe }) as SuperTokensConfig);
    isSuperTokensInitialized = true;
  }
};
